<template>
  <footer class="section-pad pt-0">
    <div class="container-nm">
      <div class="nm-divider-glow mb-4" />
      <div class="nm-panel nm-panel--inset footer-panel p-4 p-md-5">
        <div class="row g-4">
          <div class="col-lg-4">
            <img src="/logo.svg" alt="NODEMOS" class="footer-logo mb-3" />
            <p class="nm-tagline mb-0" style="font-size: 0.95rem">{{ tagline }}</p>
          </div>
          <div class="col-lg-4">
            <p class="footer-heading mb-3">NODEMOS - A Hartenstein GmbH Brand</p>
            <p class="text-muted small mb-2">{{ brand.descriptor }}</p>
            <p class="text-muted small mb-1">{{ brand.location }}</p>
            <p class="text-muted small mb-0">{{ legalEntity.address }}</p>
          </div>
          <div class="col-lg-4">
            <p class="footer-heading mb-3">Explore</p>
            <nav class="footer-nav d-flex flex-column gap-2">
              <RouterLink
                v-for="link in footerLinks"
                :key="link.to"
                :to="link.to"
                class="footer-nav__link"
              >
                {{ link.label }}
              </RouterLink>
            </nav>
          </div>
        </div>
        <div class="nm-divider-glow my-4" />
        <div class="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-3">
          <div>
            <p class="text-muted small mb-2">© {{ year }} NODEMOS. All rights reserved.</p>
            <nav class="footer-legal d-flex flex-wrap gap-3">
              <RouterLink
                v-for="link in legalLinks"
                :key="link.to"
                :to="link.to"
                class="footer-legal__link"
              >
                {{ link.label }}
              </RouterLink>
            </nav>
          </div>
          <RouterLink to="/contact" class="nm-btn nm-btn--ghost nm-btn--sm">
            <i class="fa-solid fa-envelope" aria-hidden="true" />
            Contact us
          </RouterLink>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { tagline, brand, footerLinks } from '@/content/site'
import { legalEntity, legalLinks } from '@/content/legal'

const year = new Date().getFullYear()
</script>

<style scoped>
.footer-panel {
  background: var(--nm-bg-abyss);
}

.footer-logo {
  height: 1.65rem;
  width: auto;
  display: block;
}

.footer-heading {
  font-size: 0.78rem;
  font-weight: var(--nm-font-weight-semibold);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nm-text-secondary);
  margin-bottom: 0;
}

.footer-nav__link {
  font-size: 0.92rem;
  color: var(--nm-text-muted);
  text-decoration: none;
  transition: color var(--nm-duration) var(--nm-ease);
}

.footer-nav__link:hover {
  color: var(--nm-accent-glow);
}

.footer-legal__link {
  font-size: 0.82rem;
  color: var(--nm-text-muted);
  text-decoration: none;
  transition: color var(--nm-duration) var(--nm-ease);
}

.footer-legal__link:hover {
  color: var(--nm-accent-glow);
}
</style>